import { useEffect, useState } from 'react'
import { getAirlineFromCallsign } from '../lib/utils'
import AirlineLogo from './AirlineLogo'

export default function MinimalDisplay({ flights }) {
  const [index, setIndex] = useState(0)
  
  useEffect(() => {
    if (flights.length <= 1) return
    const interval = setInterval(() => setIndex(i => (i + 1) % flights.length), 6000)
    return () => clearInterval(interval)
  }, [flights.length])
  
  const f = flights[index] || {}
  const airline = getAirlineFromCallsign(f.callsign)
  
  const formatAlt = (alt) => !alt ? '---' : alt >= 1000 ? (alt/1000).toFixed(1)+'k ft' : alt+' ft'
  const formatSpd = (vel) => !vel ? '---' : Math.round(vel * 2.23694)+' mph'
  
  return (
    <div className="h-screen w-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <AirlineLogo iata={airline.iata} size="sm" />
          <span className="text-white/60 text-sm tracking-[0.3em] uppercase">{airline.name}</span>
        </div>
        <div className="text-white text-8xl md:text-9xl font-bold tracking-tighter font-mono">{f.callsign || '---'}</div>
        <div className="flex items-center justify-center gap-8 mt-8 text-white/50 font-mono text-lg">
          <span>{formatAlt(f.altitude)}</span><span className="text-white/20">|</span><span>{formatSpd(f.velocity)}</span><span className="text-white/20">|</span><span>{f.distance} NM</span>
        </div>
        {f.route && <div className="text-white/30 text-sm mt-4 tracking-widest">{f.route[0]} → {f.route[1]}</div>}
      </div>
      <div className="absolute bottom-0 left-0 h-1 bg-white/10 w-full">
        <div className="h-full bg-white/40 transition-all duration-1000" style={{ width: `${((index + 1) / flights.length) * 100}%` }} />
      </div>
    </div>
  )
}
